import React from 'react';
import { uniq } from 'lodash';
import { getPixels, sendFBCLID, sendTTCLID } from '../Requests/AppRequests';
import DomainCheckHelper from '../Helpers/DomainCheckHelper';
import {
  getAffidFromLocalStorage,
  getUIDFromLocalStorage,
  hasProperty,
  selectVariantByForm,
} from './utils';
import BrowserStorage from '../Helpers/BrowserStorage';
import { getUrlParams } from '../Helpers/URLParser';
import autoFormsObject from './autoFormsObject';
import lifeFormsObject from './lifeFormsObject';
import petFormsObject from './petFormsObject';
import updateMainStateAction from '../redux/Modules/Main/main.actions';

const availableVariantsFunc = () => {
  const allForms = [
    ...Object.values(autoFormsObject),
    ...Object.values(lifeFormsObject),
    ...Object.values(petFormsObject),

  ];
  const variants = {};
  allForms.forEach((form) => {
    variants[form.formFromUrl] = [...(variants[form.formFromUrl] || []), form.variantFromUrl];
  });
  Object.keys(variants).forEach((formKey) => {
    variants[formKey] = [...uniq(variants[formKey])];
  });
  return variants;
};

export const getDefaultPhonesBySite = () => {
  if (window.location.href.indexOf('home-insure') >= 0) {
    return '1-855-910-8813';
  }

  if (DomainCheckHelper.checkDomain() === 'life') {
    return '1-888-609-0647';
  }
  return '1-888-804-5641';
};

export function usePrevious(value) {
  const ref = React.useRef();
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const gclidAffiliates = [
  85,
  1434,
  1852,
  1436,
  1437,
  668,
  1438,
  1439,
  669,
  1795,
  1796,
  2025,
  730,
  1443,
  673,
  1444,
  1445,
  2021,
  2027,
  10027,
  10028,
  10029,
  10030,
  10031,
  1153,
  1154,
  1440,
  1441,
  1442,
];

const fbclidAffiliates = [
  2021,
  2023,
  4086,
];

const ttclidAffiliates = [
  2027,
  2022,
  2024,
  4085,
  10004,
];

const scidAffiliates = [
  1512,
  10033,
];

const setSnapID = (snapCookie, newParam, appState, dispatch, updateAppState) => {
  const paramValue = snapCookie.split('=')[1].replace(';', '');
  const newUrlParams = { ...appState.urlParams };
  if (hasProperty.call(newUrlParams, newParam)) {
    window.history.replaceState(null, null, window.location.search.replace(`${newParam}=${newUrlParams[newParam]}`, `${newParam}=${paramValue}`));
  } else {
    window.history.replaceState(null, null, `${window.location.search}&${newParam}=${paramValue}`);
  }
  newUrlParams[newParam] = paramValue;
  dispatch(updateMainStateAction({ urlParams: newUrlParams }));
  updateAppState({ urlParams: { ...newUrlParams } });
};

export const checkToSetSnapID = (appState, dispatch, updateAppState) => {
  let loaded = false;
  const snapParam = '_scid';
  const newParam = 's3';
  if (appState.affid && +appState.affid && scidAffiliates.indexOf(+appState.affid) > -1) {
    [1, 2, 3, 4, 5].forEach((secondTimeout) => setTimeout(() => {
      if (loaded === false) {
        const cookies = document.cookie;
        if (cookies) {
          const cookieArray = cookies.split(' ');
          if (cookieArray && cookieArray.length) {
            const snapCookie = cookieArray.filter((cookie) => cookie.split('=')[0] === snapParam)[0];
            if (snapCookie) {
              setSnapID(snapCookie, newParam, appState, dispatch, updateAppState);
              loaded = true;
            }
          }
        }
      }
    }, +`${secondTimeout}000`));
  }
};

function placeCLID(affid, urlParams, affilliateObject, newParam, paramValue) {
  if (!!affid && affilliateObject.indexOf(+affid) > -1 && !!urlParams[paramValue]) {
    const newUrlParams = { ...urlParams };
    if (hasProperty.call(newUrlParams, newParam)) {
      window.history
        .replaceState(null, null, window.location.search.replace(`${newParam}=${newUrlParams[newParam]}`, `${newParam}=${newUrlParams[paramValue]}`));
    } else {
      window.history.replaceState(null, null, `${window.location.search}&${newParam}=${newUrlParams[paramValue]}`);
    }
    newUrlParams[newParam] = newUrlParams[paramValue];
    return newUrlParams;
  }
  return urlParams;
}

function handleTTCLID(affid, urlParams, siteID, uuid) {
  if (!!affid && ttclidAffiliates.indexOf(+affid) > -1 && !!urlParams.ttclid) {
    sendTTCLID(siteID, uuid, urlParams.ttclid);
  }
}

function handleFBCLID(affid, urlParams, siteID, uuid) {
  if (!!affid && fbclidAffiliates.indexOf(+affid) > -1 && !!urlParams.fbclid) {
    sendFBCLID(siteID, uuid, urlParams.fbclid);
  }
}

export function getInitParams() {
  let formFromUrl;
  let variantFromUrl;
  let urlParams = getUrlParams();
  const affid = urlParams.affid || getAffidFromLocalStorage();
  const formName = urlParams.form && decodeURIComponent(urlParams.form.toString().toLowerCase());
  if (hasProperty.call(urlParams, 'affid')) {
    BrowserStorage.saveToLocalStorage('affidASR', urlParams.affid);
    delete urlParams.affid;
  }

  urlParams = placeCLID(affid, urlParams, gclidAffiliates, 's4', 'gclid');

  const availableVariants = availableVariantsFunc();
  if (hasProperty.call(urlParams, 'form')) {
    formFromUrl = formName;
    delete urlParams.form;
    if (hasProperty.call(urlParams, 'variant')
      && hasProperty.call(availableVariants, formFromUrl)
      && availableVariants[formFromUrl].indexOf(urlParams.variant) >= 0) {
      variantFromUrl = urlParams.variant;
      formFromUrl = formName.slice(0, -1) + (formName > 9 ? variantFromUrl : variantFromUrl - 1);
      delete urlParams.variant;
    } else if (hasProperty.call(urlParams, 'variant_number')
      && hasProperty.call(availableVariants, formFromUrl)
      && availableVariants[formFromUrl].indexOf(urlParams.variant_number) >= 0) {
      variantFromUrl = urlParams.variant_number;
      formFromUrl = formName.slice(0, -1) + (formName > 9 ? variantFromUrl : variantFromUrl - 1);
      delete urlParams.variant_number;
    }
    if (formFromUrl.indexOf('pet') >= 0 || window.location.href.indexOf('pet') >= 0) {
      [formFromUrl, variantFromUrl] = selectVariantByForm(formFromUrl, variantFromUrl, petFormsObject, '1001', 1);
    } else if (formFromUrl.indexOf('life') >= 0 || window.location.href.indexOf('life') >= 0) {
      [formFromUrl, variantFromUrl] = selectVariantByForm(formFromUrl, variantFromUrl, lifeFormsObject, '1001', 1);
    } else {
      [formFromUrl, variantFromUrl] = selectVariantByForm(formFromUrl, variantFromUrl, autoFormsObject, '8004', 4);
    }
  } else if (window.location.href.indexOf('as-mui') >= 0) {
    [formFromUrl, variantFromUrl] = selectVariantByForm('8', '1');
  } else if (window.location.href.indexOf('as-snap') >= 0) {
    [formFromUrl, variantFromUrl] = selectVariantByForm('9', '1');
  } else if (DomainCheckHelper.checkDomain() === 'life') {
    [formFromUrl, variantFromUrl] = selectVariantByForm('1', '1', lifeFormsObject);
  } else if (DomainCheckHelper.checkDomain() === 'pet') {
    [formFromUrl, variantFromUrl] = selectVariantByForm('1000', '1', petFormsObject);
  }
  // eslint-disable-next-line camelcase
  return [affid, formFromUrl, variantFromUrl, urlParams];
}

const returnParams = (
  state,
  ip,
  uuid,
  geoData,
  thData,
  siteID,
  variantObject,
  defaultForm,
  defaultVariant,
  retargetingPayload,
  trafficApproved,
  inboundNumber,
  device,
  data,
  denyListed,
  international,
  unsupportedState,
) => (
  {
    ...state,
    ip,
    uuid,
    geoData,
    siteID,
    variantObject,
    retargetingPayload,
    trafficApproved,
    inboundNumber,
    device,
    tyType: data.ty_type || data.tyType || 'default',
    lbType: data.lbType || 'ty',
    entry_time: (data || {}).entry_time || (data || {}).entryTime,
    redirect: '',
    th: thData.th || false,
    thStep: thData.th_step || 'none',
    site_id: siteID,
    showAddressPage: true,
    form: variantObject.form || defaultForm,
    variant_number: variantObject.variant || defaultVariant,
    denyListed,
    international,
    unsupportedState,
  }
);

export const setLocalStorageValuesFromInitialData = (data) => {
  if (data && data.device && data.platform && data.browser) {
    localStorage.setItem('device_track', data.device);
    localStorage.setItem('platform_track', data.platform);
    localStorage.setItem('browser_track', data.browser);
  }
};

export const setInitialData = async (state, initialDataRequest, siteID, uuidOverride = '') => {
  try {
    let ip;
    let uuid;
    let geoData = false;
    let variantObject;
    let thData;
    let retargetingPayload;
    let trafficApproved;
    let inboundNumber;
    let device;
    let denyListed;
    let international;
    let unsupportedState;
    const { data } = await initialDataRequest;

    if (data) {
      setLocalStorageValuesFromInitialData(data);
      uuid = getUIDFromLocalStorage(data.uid, uuidOverride);
      ip = data.ip;
      device = data.device;
      if (state.urlParams.zl !== '0') {
        if (data.geoData) {
          geoData = data.geoData ? data.geoData : false;
          geoData.fullState = geoData && geoData.state ? geoData.state : false;
          geoData.state = geoData && geoData.stateAbbreviation ? geoData.stateAbbreviation : false;
        } else {
          geoData = data.geo ? JSON.parse(data.geo) : false;
        }
      }
      thData = data.thData ? JSON.parse(data.thData) : [];
      variantObject = data.variantObject ? JSON.parse(data.variantObject) : {};
      retargetingPayload = data.retargetingPayload ? JSON.parse(data.retargetingPayload) : false;
      trafficApproved = (typeof (data.traffic_approved) !== 'undefined') ? data.traffic_approved : true;
      inboundNumber = data.inboundNumber || getDefaultPhonesBySite();
      denyListed = data.denyListed || false;
      international = data.international || false;
      unsupportedState = data.unsupportedState || false;
    }
    handleTTCLID(state.affid, state.urlParams, siteID, uuid);
    handleFBCLID(state.affid, state.urlParams, siteID, uuid);

    return returnParams(
      state,
      ip || '',
      uuid || '',
      geoData,
      thData,
      siteID,
      variantObject,
      state.form,
      state.variant_number,
      retargetingPayload,
      trafficApproved,
      inboundNumber,
      device,
      data,
      denyListed,
      international,
      unsupportedState,
    );
  } catch (e) {
    console.error(e);
    if (localStorage.getItem('badNetworkRefresh') !== 'true') {
      localStorage.setItem('badNetworkRefresh', 'true');
      window.location.reload();
    }
    return returnParams(
      state,
      '',
      '',
      {},
      [],
      {},
      '',
      9,
      6,
      false,
      true,
      getDefaultPhonesBySite(),
      '',
      {},
    );
  }
};

export const getPixelsData = async (state) => {
  const siteID = DomainCheckHelper.getSiteID();
  const { data } = await getPixels(state.affid, siteID, state.thStep || 'none', state.urlParams.user_agent, state.device || false);
  return data;
};
